import { CaretLeft, CaretRight } from "@phosphor-icons/react";
import cx from "classnames";

import {
  PANE_HEADER_ICON_SIZE,
  paneHeaderIconButtonClassName,
} from "./PaneHeader";

/** Alias of `paneHeaderIconButtonClassName` for nav/prev-next call sites. */
export const chevronNavButtonClassName = paneHeaderIconButtonClassName;

/**
 * Prev/next chevron controls keep a light outline (unlike the ghost
 * close/collapse controls) so the navigation affordance draws the eye. Applies
 * to every ChevronNavButton — comment nav, review nav, PDF page nav — so the
 * affordance is consistent wherever prev/next appears.
 */
export const chevronNavButtonOutlineClassName = cx(
  paneHeaderIconButtonClassName,
  "border border-puntt-neutral-gray-4 hover:border-puntt-neutral-gray-6",
);

export function ChevronNavButton({
  direction,
  disabled,
  onClick,
  "aria-label": ariaLabel,
  "data-testid": dataTestId,
}: {
  direction: "left" | "right";
  disabled?: boolean;
  onClick?: () => void;
  "aria-label": string;
  "data-testid"?: string;
}) {
  const Icon = direction === "left" ? CaretLeft : CaretRight;
  return (
    <button
      type="button"
      disabled={disabled}
      onClick={onClick}
      aria-label={ariaLabel}
      data-testid={dataTestId}
      className={chevronNavButtonOutlineClassName}
    >
      <Icon size={PANE_HEADER_ICON_SIZE} aria-hidden="true" />
    </button>
  );
}
